import type { EChargeType } from './Product';
import type Product from './Product';

class Currency {
  id: number;
  name: string;
}

export class Payments {
  charge_type: EChargeType;
  currency: Currency;
  price: number;
  has_promotional_price: boolean;
  promotional_price: number;
  date_promotional_price: string;

  constructor(payments: Product) {
    this.charge_type = payments.charge_type;
    this.currency = payments.currency;
    this.price = payments.price;
    this.has_promotional_price = payments.has_promotional_price;
    this.promotional_price = payments.promotional_price;
    this.date_promotional_price = payments.date_promotional_price;
  }
}

export class Subscription extends Payments {
  recurring_frequency_type: string;
  recurring_frequency: number;
  undetermined_charges: boolean;
  limit_charges: number;
  membership_fee: boolean;
  membership_price: number;
  has_trial: boolean;
  trial_days: number;
  recurring_start_charging: string;
  deliver_first_charge: boolean;
  remove_access: boolean;
  allow_installment_checkout: boolean;

  constructor(subscription: Product) {
    super(subscription);
    this.recurring_frequency_type = subscription.recurring_frequency_type;
    this.recurring_frequency = subscription.recurring_frequency || 0;
    this.undetermined_charges = subscription.undetermined_charges || false;
    this.limit_charges = subscription.limit_charges || 0;
    this.membership_fee = subscription.membership_fee || false;
    this.membership_price = subscription.membership_price;
    this.has_trial = subscription.has_trial || false;
    this.trial_days = subscription.trial_days || 0;
    this.recurring_start_charging = subscription.recurring_start_charging;
    this.deliver_first_charge = subscription.deliver_first_charge;
    this.remove_access = subscription.remove_access;
    this.allow_installment_checkout = subscription.allow_installment_checkout;
  }
}

export class Checkout {
  allows_boleto: boolean;
  url_thankyou_boleto: string;
  allows_card: boolean;
  url_thankyou_card: string;
  allows_paypal: boolean;
  allows_multiple_cards: boolean;
  document_on_checkout: boolean;
  ask_address_checkout: boolean;
  ask_address_thanks: boolean;
  hide_quantity: boolean;

  constructor(checkout: Checkout) {
    this.allows_boleto = checkout.allows_boleto;
    this.url_thankyou_boleto = checkout.url_thankyou_boleto;
    this.allows_card = checkout.allows_card;
    this.url_thankyou_card = checkout.url_thankyou_card;
    this.allows_paypal = checkout.allows_paypal;
    this.allows_multiple_cards = checkout.allows_multiple_cards;
    this.document_on_checkout = checkout.document_on_checkout;
    this.ask_address_checkout = checkout.ask_address_checkout;
    this.ask_address_thanks = checkout.ask_address_thanks;
    this.hide_quantity = checkout.hide_quantity;
  }
}

export class Recovery {
  sales_recovery: boolean;
  recovery_email: string;
  constructor(recovery: Recovery) {
    this.sales_recovery = recovery.sales_recovery;
    this.recovery_email = recovery.recovery_email;
  }
}
